module.exports = __webpack_public_path__ + "static/media/project2.030cc284.png";